<template>
  <div class="card card-small">
    <div class="card-body p-0 pb-3 text-center">
      <template v-if="loadError">
        <d-alert
          show
          theme="warning">
          Wczytywanie danych nie powiodło się.
          <a
              href="javascript:window.location.reload();"
              class="alert-link">
              Odśwież stronę
          </a>
          aby spróbować ponownie.
        </d-alert>
      </template>
      <template v-else>
        <div
          v-if="!loaded"
          class="overlay-loading">
          <h2 class="preloader isLoading">Trwa ładowanie</h2>
        </div>
        <d-list-group class="p-3" flush>
          <table class="table mb-0 responsive-table">
            <thead class="bg-light">
              <tr>
                <th scope="col" class="border-0">Sygnatura sprawy</th>
                <th scope="col" class="border-0">Osoba egzekwowana</th>
                <th scope="col" class="border-0">Komornik</th>
                <th scope="col" class="border-0">Weryfikacja</th>
                <th scope="col" class="border-0">Pozyskano</th>
                <th scope="col" class="border-0">Status sprawy</th>
                <th scope="col" class="border-0">Akcje</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(execution, index) in executions" :key="index">
                <td>
                  <dt>Sygnatura sprawy</dt>
                  <dd>{{ execution.number }}</dd>
                </td>
                <td class="text-left">
                  <dt>Osoba egzekwowana</dt>
                  <dd v-html="executionPerson(execution)"></dd>
                </td>
                <td>
                  <dt>Komornik</dt>
                  <dd v-if="execution.bailiff"><a href="#" @click.prevent="showBailiff(execution.bailiff)">{{ execution.bailiff.name }}</a></dd>
                </td>
                <td>
                  <dt>Weryfikacja</dt>
                  <dd>
                    <span
                      :id="'execution-' + execution.id"
                      :class="{'text-success' : allApplicationsCompleted(execution)}">
                      {{ completeApplications(execution.applications) }}/{{ execution.applications.length }}
                    </span>
                    <d-popover
                      :target="'execution-' + execution.id"
                      :triggers="['hover']"
                      theme="black"
                      container=".shards-demo--example--tooltip-02">
                      <div
                        v-for="(application, applicationIndex) in execution.applications"
                        :key="`application-${applicationIndex}-${execution}`"
                        class="d-flex justify-content-between mt-1 mb-1" >
                        <span>
                          {{ application.application_name ? application.application_name : 'Brak nazwy' }}
                        </span>
                        <i
                          v-if="application.status.toString() === '1'"
                          class="fa fa-check ml-3 text-success">
                        </i>
                      </div>
                    </d-popover>
                  </dd>
                </td>
                <td>
                  <dt>Pozyskano</dt>
                  <dd>{{ execution.contributions_sum }} zł</dd>
                </td>
                <td>
                  <dt>Status sprawy</dt>
                  <dd>
                    <span v-if="execution.applications && allApplicationsCompleted(execution)" class="text-success">Zakończona</span>
                    <span v-else>W trakcie</span>
                  </dd>
                </td>
                <td>
                  <dt>Akcje</dt>
                  <dd class="wsnw">
                    <d-button
                      @click.prevent="editExecution(execution)"
                      class="mr-1 mr-3">
                      <i class="material-icons">edit</i> Edytuj
                    </d-button>
                    <d-button
                      @click.prevent="removeExecution(execution)"
                      theme="danger"
                      class="mr-1 mr-3">
                      <i class="material-icons">delete</i> Usuń
                    </d-button>
                  </dd>
                </td>
              </tr>
              <tr v-if="!executions.length">
                <td colspan="7" class="text-center text-info">
                  Brak spraw do wyświetlenia&hellip;
                </td>
              </tr>
            </tbody>
          </table>
        </d-list-group>
      </template>
    </div>

    <bailiff-modal
      v-if="bailiff"
      :props="bailiff"
      :show.sync="bailiff_modal">
    </bailiff-modal>
  </div>
</template>

<script>
import BailiffModal from '../bailiffs/BailiffModal';
import BailiffUtil from '../../utils/bailiff';
import { mapGetters } from 'vuex';

export default {
  name: 'ExecutionsList',
  components: {
    BailiffModal
  },
  data () {
    return {
      bailiff: _.clone(BailiffUtil),
      bailiff_modal: false,
      executions: [],
      loaded: false,
      loadError: false,
    }
  },
  computed: {
    ...mapGetters([
      'allBailiffs',
    ]),
  },
  mounted () {
    this.fetchData();
  },
  methods: {
    fetchData () {
      axios.post('api/contracts-case/get-cases/' + this.$route.params.schedule_id).then(response => {
        if (response.data != undefined) {
          this.executions = response.data;
        } else {
          this.executions = [];
        }
        this.loaded = true;
      }).catch((errors) =>{
        console.log(errors);
        this.loaded = true;
        this.loadError = true;
      })
    },
    showBailiff (bailiff) {
      this.bailiff = bailiff;
      this.bailiff_modal = true;
    },
    executionPerson (execution) {
      let person = '';
      if (execution.guarantor_id) {
        person = `<span class="text-light">Poręczyciel</span><br />
          ${execution.guarantor_name} ${execution.guarantor_last_name}`;
      } else if (execution.client_type === 'corporation') {
        person = `<span class="text-light">Pożyczkobiorca</span><br />
          ${execution.company_name}`;
      } else {
        person = `<span class="text-light">Pożyczkobiorca</span><br />
          ${execution.client_name} ${execution.client_last_name}`;
      }
      return person;
    },
    toNumber (number) {
      return Vue.toNumber(number);
    },
    allApplicationsCompleted ({applications}) {
      return this.completeApplications(applications) === applications.length;
    },
    editExecution(execution) {
      this.$bus.$emit('execution-edit', execution.id)
    },
    completeApplications (applications) {
      const reducedApplications = applications.reduce((accumulator, application) => {
        if (application.status.toString() === '1') {
          return accumulator + 1;
        }
        return accumulator;
      }, 0);
      return reducedApplications;
    },
    bailiffEdit (execution) {
      this.$router.push({name: 'bailiff-edit', params: {id: execution.bailiff_id}});
    },
    removeExecution(execution){
      Vue.swal({
        title: 'Uwaga',
        html: 'Czy potwierdzasz usunięcie sprawy?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Tak',
        cancelButtonText: 'Nie',
        buttonsStyling: true
      }).then((logout) => {
        if(logout.value){
          axios.post('api/contracts-case/remove-case/' + execution.id).then(response => {
            Vue.swal({
              type: 'success',
              title: 'Sprawa została usunięta.',
              showConfirmButton: true,
            }).then(() => {
              this.fetchData()
            })
          }).catch((errors) =>{
            console.log(errors);
          })
        }
      }).catch((errors) =>{
        console.log(errors);
      })
    }
  }
}
</script>

<style>
.action-cell, .id-cell{
  width: 200px;
}

.execution-note{
  min-width: 150px;
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
  white-space: nowrap;
}
</style>
<style scoped>
.btn{
  min-width: 70px;
}
</style>
